import styled from 'styled-components';
import { rotate360 } from 'styles/animation';
import { hexa, marginReplacer } from 'styles/utils';

export const SpinnerStyled = styled.div`
  display: inline-flex;
  width: ${props => (props.size === 'large' ? '2rem' : '1em')};
  height: ${props => (props.size === 'large' ? '2rem' : '1em')};
  border: 2px solid
    ${props =>
      `${hexa(props.theme.color[props.isDark ? 'wfWhite' : 'wfBlue'], 0.2)}`};
  border-left-color: ${props =>
    props.autoColor
      ? 'currentColor'
      : props.theme.color[props.isDark ? 'wfWhite' : 'wfBlue']};
  margin: ${props => (props.margin ? marginReplacer(props.margin) : '0')};
  position: relative;
  animation: ${rotate360} 1s infinite linear;
  &,
  &::after {
    border-radius: 50%;
  }
`;

export const StorybookWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 300px;
  background-color: ${props =>
    props.theme.color[props.isDark ? 'wfBlack' : 'wfWhite']};
`;
